var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        title: _vm.$t(
          _vm.isUpdate ? "label.domain_update" : "label.domain_add"
        ),
        scrollable: "",
        "hide-footer": "",
      },
    },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                label: _vm.$t("label.domain_name"),
                "label-for": "set-domain-label-input",
              },
            },
            [
              _c("b-form-input", {
                attrs: {
                  id: "set-domain-label-input",
                  type: "text",
                  disabled: _vm.loading,
                  placeholder: _vm.$t("label.domain_add_placeholder"),
                  required: "",
                },
                model: {
                  value: _vm.domain.dac_label,
                  callback: function ($$v) {
                    _vm.$set(_vm.domain, "dac_label", $$v)
                  },
                  expression: "domain.dac_label",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                label: _vm.$t("label.domain_color"),
                "label-for": "set-domain-color-input",
              },
            },
            [
              _c("b-form-input", {
                attrs: {
                  id: "set-domain-color-input",
                  type: "color",
                  disabled: _vm.loading,
                },
                model: {
                  value: _vm.domain.dac_data.display.color,
                  callback: function ($$v) {
                    _vm.$set(_vm.domain.dac_data.display, "color", $$v)
                  },
                  expression: "domain.dac_data.display.color",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isUpdate
            ? _c(
                "b-form-checkbox",
                {
                  attrs: {
                    id: "set-domain-is-enable-input",
                    value: true,
                    "unchecked-value": false,
                    disabled: _vm.loading,
                  },
                  model: {
                    value: _vm.domain.dac_is_enable,
                    callback: function ($$v) {
                      _vm.$set(_vm.domain, "dac_is_enable", $$v)
                    },
                    expression: "domain.dac_is_enable",
                  },
                },
                [_vm._v("\n      " + _vm._s(_vm.$t("label.active")) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    type: "submit",
                    variant: "primary",
                    disabled: _vm.loading,
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(_vm.isUpdate ? "btn.validate" : "btn.add_domain")
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-alert",
            {
              staticClass: "mt-3",
              attrs: { show: _vm.error !== null, variant: "danger" },
            },
            [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }